import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import {optionsToArray} from "@app/utils/CommonUtils";
import {callApiSearchSavedList} from "@pages/savedlist/common/Services";
import {MailTempType} from "@pages/email/common/Constant";
import DVTJCUVChildrenTabManager from "@pages/email/template/dvtjcuv/DVTJCUVChildrenTabManager";


export const AcquireCddTabs = {
    INVITE_TAB: {id: 'acquire-invite-tab', title: 'Mời', templateType: MailTempType.DVTJCUV_INVITE_EMAIL},
    FU_TAB: {id: 'acquire-fu-tab', title: 'FU', templateType: MailTempType.DVTJCUV_EMAIL_FU},
    DETAIL_WITH_CANDIDATE: {id: 'acquire-detail-width-uv-tab', title: 'Chi tiết với UV quan tâm', templateType: MailTempType.DETAIL_WITH_CANDIDATE},
    SEND_TC: {id: 'acquire-send-tc-tab', title: 'Gửi T&C', templateType: MailTempType.SEND_TC},
}

export const ConnectCddEmpTabs = {
    INVITE_SEMI_FULL_TEMP_TAB: {id: 'connect-cdd-emp-invite-semi-full-temp-tab', title: 'Mời (Temp Semi-Full)'},
    INVITE_CDD_BRIEF_TABLE_TAB: {id: 'connect-cdd-emp-invite-cdd-brief-table-tab', title: 'Mời (Bảng Cdd Brief)'},
    SEND_UV_TAB: {id: 'connect-cdd-emp-send-uv-tab', title: 'Gửi UV'},
    SUGGEST_RECEIVER_UPDATE_INFO_TAB: {id: 'connect-cdd-emp-suggest-receiver-update-info-tab', title: 'Đề nghị Receiver update info'},
    FU_SUGGEST_RECEIVER_UPDATE_INFO: {id: 'connect-cdd-emp-fu-suggest-receiver-update-info', title: '(FU) Đề nghị Receiver update info '},
}

export const DVTJCUVTabs = {
    ACQUIRE_CDD_TAB: {id: 'dvtjcuv-acquire-cdd-tab', title: 'ACQUIRE CDD', children: AcquireCddTabs},
    CONNECT_CDD_EMP_TAB: {id: 'dvtjcuv-connect-cdd-tab', title: 'CONNECT CDD-EMP', children: ConnectCddEmpTabs},
}

const DVTJCUVTemplateListManager = (props) => {
    const [currentTabId, setCurrentTabId] = useState(DVTJCUVTabs.ACQUIRE_CDD_TAB.id);
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [quickSearchInput, setQuickSearchInput] = useState({});
    const [tabTotals, setTabTotals] = useState({});
    const [subTabList, setSubTabList] = useState({...DVTJCUVTabs.ACQUIRE_CDD_TAB.children});

    const searchCandidateGroups = async (searchInputConditions) => {
        let params = {}
        if (searchInputConditions) {
            params.search_conditions = {...searchInputConditions}
            params.search_conditions.tabs = optionsToArray(searchInputConditions.select_tabs)
        }

        await callApiSearchSavedList(params, (res) => {
            const resContent = res.content
            // setTotalCount(resContent.total_count)
            const groupTabTotals = {}
            resContent.tab_totals.forEach(item => {
                groupTabTotals[item.tab] = item.total
            })

            setTabTotals({...groupTabTotals})
        });
    }

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(async () => {
        await searchCandidateGroups(quickSearchInput)
    }, [quickSearchInput])

    const onTabClicked = (tabId, subTabs) => {
        setCurrentTabId(tabId);
        setSubTabList({...subTabs})
    };

    const activeTab = (tabId) => {
        if (currentTabId === tabId) {
            return 'active'
        }
        return ''
    }

    const getTabTitle = (tab) => {
        const total = tabTotals[tab.id] ? tabTotals[tab.id] : 0
        return `${tab.title} (${total})`
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Email template DVTJCUV</h3>
                    <div className='card-tools'>
                    </div>
                </div>
                <div className='card-body p-0'>
                    <ul className='nav nav-tabs' role='tablist'>
                        {Object.keys(DVTJCUVTabs).map(key => {
                            let tab = DVTJCUVTabs[key];
                            return <li className={`nav-item ${activeTab(tab.id)}`} key={`${tab.id}_tab`}>
                                <a className={`nav-link text-bold ${activeTab(tab.id)}`} data-toggle='tab' href={"#" + tab.id}
                                   onClick={() => {onTabClicked(tab.id, tab.children)}}>{getTabTitle(tab)}</a>
                            </li>
                        })}
                    </ul>
                    <div className='tab-content'>
                        {Object.keys(DVTJCUVTabs).map(key => {
                            let tab = DVTJCUVTabs[key];
                            return <div id={tab.id}  key={`${tab.id}_content`}
                                 className={`tab-pane ${activeTab(tab.id)}`}
                                 style={{height: '83vh', overflow: 'auto'}}>
                                <DVTJCUVChildrenTabManager templateType={MailTempType.DVTJCUV_INVITE_EMAIL} parentTabId={currentTabId} tabList={subTabList}/>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default DVTJCUVTemplateListManager;
